
import React, { useEffect, useState} from 'react';
import { FaArrowRight } from "react-icons/fa";
import {Link} from "react-router-dom";
import styles from './Kalender.module.css'
import stylesSmall from './SmallKalender.module.css'

import FadeInSection from '../../components/FadeInSection';

const Kalender = ({content}) => {


  const calendarId = process.env.REACT_APP_CALENDAR_ID;
  const apiKey = process.env.REACT_APP_API_KEY;
    
  
  const [events, setEvents] = useState({});
  const monthNames = [ //Array to index the months
        'JAN', 'FEB', 'MARTS', 'APRIL', 'MAJ', 'JUNI', 
        'JULI', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'
    ];



const getDate = (event) => {
  let date = '';
  if (event.start.date) {
    date = event.start.date;
  } else if (event.start.dateTime) {
    date = event.start.dateTime.split("T")[0]; // Extract date part
  } else {
    return "No date given";
  }


  const dateParts = date.split('-'); // Split "YYYY-MM-DD"
  const day = dateParts[2]; // Extract day (DD)
  const month = monthNames[parseInt(dateParts[1], 10) - 1]; // Extract month and convert to correct index

  return (
    <>
      {day}. <br /> {month}
    </>
  );
};

const getTime= (event) => {
  let startTime = '';
  let endTime = '';
  if (event.start.date) {
    startTime = 'Hele dagen';
  } else if (event.start.dateTime) {
    const returnStartTime = event.start.dateTime.split("T")[1]; // Extract date part
    startTime = returnStartTime.split(':')[0] + ':' + returnStartTime.split(':')[1]
    const returnEndTime = event.end.dateTime.split("T")[1]; // Extract date part
    endTime = returnEndTime.split(':')[0] + ':' + returnEndTime.split(':')[1]
    return startTime + ' - ' + endTime
  } else {
    startTime = "Ingen tid angivet";
  }

  return startTime 
}

const compare = (x,y) => { 
  let event1 = "";
  let event2 = "";
  
  if(x.start.date){
      event1 = new Date(x.start.date + 'T00:00:00');
      } else if (x.start.dateTime){
          event1 = new Date(x.start.dateTime);
      } else{
          console.log("no time given")
      }
  if(y.start.date){
      event2 = new Date(y.start.date + 'T00:00:00');
      } else if (y.start.dateTime){
          event2 = new Date(y.start.dateTime);
      } else{
          console.log("no time given")
      }
  return event1-event2;
}

useEffect(() => {
  async function getEvents() {
  // Calculate the start and end dates of the desired month
  const startDate = new Date().toISOString();


  const url = `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?key=${apiKey}&timeMin=${startDate}&maxResults=10&o&singleEvents=true&orderBy=startTime`;

  const response = await fetch(url, {
      method: "GET",
      headers: {
          "Content-Type": "application/json",
      },
  });

  if (response.ok) {
      const data = await response.json();
      

      if (data.items.length > 0) {
          setEvents((data.items.sort(compare)).slice(0,3));
      } else {
          setEvents([]);
      }

  } else {
      console.log("Error:", response.status);
  }
}

  getEvents()
}, [])

const SmallKalendar = () => {
  return (
    <div className={stylesSmall.smallCalendarContainer}>
      <div className={stylesSmall.eventList}>
      {events.length > 0 ? (
          events.map((event, index) => {
            // const isSecondTurn = count === 2;
            index++;

            return ( 
              <div
                key={event.id}
                className={stylesSmall[`eventPreview${index === 2 ? 'Middle' : ''}`]}>
                  <p className={stylesSmall.date}>{getDate(event)}</p>
                  <div className={stylesSmall.info}>
                    <h3 className={stylesSmall.summary}>{event.summary}</h3>
                    <h3 className={stylesSmall.dateTime}>{getTime(event)}</h3>
                  </div>
              </div>
            );
          })
        ) : (
          <h3>Ingen kommende begivenheder</h3>
        )}
      </div>
    </div>
  );
};



  return (
    <section className={styles.section1} >
        
      <div className={styles.headline}>
        <h1>{content.header}</h1>
      </div>
      <FadeInSection >
        <div className={styles.smallCalendarWrapper} >
            <SmallKalendar></SmallKalendar>
        </div>
        <div className={styles.redirect} >
          <div dangerouslySetInnerHTML={{ __html: content.text }}/>
          <Link to="/Kalender"><button>Gå til kalender <FaArrowRight className={styles.Arrow}/></button></Link>
        </div>
      </FadeInSection>
    </section>
  );
};

export default Kalender;